let $ = require('jquery');
window.$ = window.jQuery = $;
require('hammerjs');
require('popper.js');
require('bootstrap');

require('./header.js');
